import { EncounterMode } from '@dreryk/egabinet-waitlist-frontend-api';

import { createInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

export const ENCOUNTER_MODES: EncounterMode[] = ['ON_SITE', 'VIDEO_CONSULTATION'];

const ENCOUNTER_MODE_TO_SEARCH_PARAM: Record<EncounterMode, number> = {
   VIDEO_CONSULTATION: 0,
   ON_SITE: 1,
};

export const createEncounterModesTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenEncounterModes: EncounterMode[]) => string) => {
   return (chosenEncounterModes) => {
      if (chosenEncounterModes.length === 1) {
         return translate(translationKeys.encounterModeMap[chosenEncounterModes.at(0)!]);
      }
      const translationKey = createInterpolatedTranslationKey(translationKeys.chosenOptions, {
         count: chosenEncounterModes.length,
         totalCount: ENCOUNTER_MODES.length,
      });
      return translate(translationKey);
   };
};

export const encounterModesDeserializer = (currentParamValue: string | null): EncounterMode[] => {
   return FilterPanel.paramToArray(
      currentParamValue,
      'number',
      (item) => ENCOUNTER_MODES.find((mode) => ENCOUNTER_MODE_TO_SEARCH_PARAM[mode] === item)!
   );
};

export const encounterModesCodec: FilterPanelControllerCodecConfigArray<EncounterMode> = {
   type: 'array',
   items: ENCOUNTER_MODES,
   keyGenerator: (mode) => ENCOUNTER_MODE_TO_SEARCH_PARAM[mode],
};

export const encounterModesDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   EncounterMode[],
   WaitlistFilterPanelSearchParam.ENCOUNTER_MODE
> = (currentEncounterModes) => {
   return currentEncounterModes.map((mode) => ({
      targetValue: currentEncounterModes.filter((currentEncounterMode) => currentEncounterMode !== mode),
      label: translationKeys.encounterModeMap[mode],
      testId: mode,
   }));
};
